// When the map should offer home-city enrichment.
// A contact counts as covered when a home city or a home region is saved.
export const HOME_CITY_PROMPT_MIN_CONTACTS = 20;
export const HOME_CITY_PROMPT_MAX_COVERAGE = 0.3;
export const HOME_CITY_PROMPT_MESSAGE = 'We can find where your contacts live.';

function text(value) {
  return String(value || '').trim();
}

export function isOwnContact(contact, selfId) {
  if (!contact) return false;
  if (selfId && contact.id === selfId) return true;
  if (contact.is_self) return true;
  if (contact.source === 'self_card') return true;
  return false;
}

export function homeCityOrRegion(contact) {
  const addresses = Array.isArray(contact?.addresses) ? contact.addresses : [];
  const home = addresses.find((row) => String(row?.type || '').toLowerCase() === 'home');
  const city = text(home?.city) || text(contact?.home?.city) || text(contact?.city);
  const region = text(home?.state) || text(home?.region) || text(contact?.home?.state) || text(contact?.state);
  if (city || region) return { city, region };
  const first = addresses[0];
  if (!first) return { city: '', region: '' };
  return {
    city: text(first.city),
    region: text(first.state) || text(first.region),
  };
}

export function homeCityCoverage(contacts, selfId) {
  const people = (contacts || []).filter((contact) => contact && !contact.deleted_at && !isOwnContact(contact, selfId));
  const covered = people.filter((contact) => {
    const place = homeCityOrRegion(contact);
    return Boolean(place.city || place.region);
  }).length;
  const total = people.length;
  return {
    total,
    covered,
    ratio: total ? covered / total : 1,
  };
}

export function shouldShowHomeCityPrompt(contacts, selfId, dismissed) {
  if (dismissed) return false;
  const { total, ratio } = homeCityCoverage(contacts, selfId);
  return total >= HOME_CITY_PROMPT_MIN_CONTACTS && ratio < HOME_CITY_PROMPT_MAX_COVERAGE;
}
